import { IconCircle, SectionHeader } from "./shared";
import bannerImage from "../../assets/home/benefits-banner.jpg";
import iconPercent from "../../assets/home/b-percent.svg";
import iconClock from "../../assets/home/b-clock.svg";
import iconBriefcase from "../../assets/home/b-briefcase.svg";

const BENEFITS = [
  { title: "Competitive Interest Rates", desc: "Explore personal loans with competitive interest rates and transparent charges.", icon: iconPercent },
  { title: "First 5 Days Interest-Free", desc: "Enjoy the first 5 days interest-free, subject to applicable terms and conditions.", icon: iconClock },
  { title: "Made for Salaried Professionals", desc: "Personal loan solutions designed specifically for salaried individuals.", icon: iconBriefcase },
];

export default function HomeBenefits() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto">
        <div className="lg:min-h-[155px]">
          <SectionHeader
            badge="Benefits"
            title="THE BENEFITS OF FASTRUPEES"
            subtitle="Discover the key advantages of choosing FastRupees for your personal loan needs."
          />
        </div>

        <div className="mt-6 lg:mt-0 w-full aspect-[1280/209] rounded-[20px] sm:rounded-[42.244px] overflow-hidden">
          <img src={bannerImage} alt="Benefits" loading="lazy" className="size-full object-cover" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-10">
          {BENEFITS.map((b) => (
            <div key={b.title} className="flex flex-col gap-4 bg-[#f8fafc] rounded-[24px] p-6">
              <IconCircle size={48}>
                <img alt="" src={b.icon} className="size-6" />
              </IconCircle>
              <p className="font-bold text-[#1a1a4b] text-[16px]">{b.title}</p>
              <p className="text-[#6a7282] text-[13px] leading-[18px]">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center pt-6">
          <a
            href="/products"
            className="inline-flex items-center justify-center px-6 py-[14px] bg-[#5c168a] rounded-full font-bold text-[16px] text-white whitespace-nowrap transition-opacity hover:opacity-90"
          >
            Explore Personal Loans
          </a>
        </div>
      </div>
    </section>
  );
}
